import StoreManager from '../redux/';
import { Actions as SessionActions } from '../redux/SessionRedux';
import ApiService from './ApiService';

class PendingTasksPollingService {
    constructor() {
        this.pendingTasksPollingInterval = null;
        this.pollingInterval = 30000; // 30秒
        this.isPolling = false;
    }

    startPolling() {
        if (this.isPolling) {
            return;
        }

        this.isPolling = true;
        
        this.fetchPendingTasks();
        
        this.pendingTasksPollingInterval = setInterval(() => {
            this.fetchPendingTasks();
        }, this.pollingInterval);
    }

    stopPolling() {
        if (!this.isPolling || !this.pendingTasksPollingInterval) {
            return;
        }

        clearInterval(this.pendingTasksPollingInterval);
        this.pendingTasksPollingInterval = null;
        this.isPolling = false;
    }

    fetchPendingTasks() {
        const store = StoreManager.getStore();
        const state = store.getState();
        
        const userId = state.session.userId;
        const regionId = state.session.regionId;
        
        const requestData = {
            curUserId: userId,
            RegionId: regionId
        };
        
        ApiService.post('/web/admin/todotask/getpendingtasks', requestData, 
            (response) => {
                if (response) {
                    const { pendingRequests, myPendingRequests } = response;
                    
                    if (pendingRequests) {
                        store.dispatch(SessionActions.updatePendingRequestsFromResponse(pendingRequests));
                    }

                    if (myPendingRequests) {
                        store.dispatch(SessionActions.updateMyPendingRequests(myPendingRequests));
                    }
                }
            },
            (error) => {
                // 检查是否是取消操作相关的错误，如果是则静默处理，不记录错误
                if (this._isCancelError(error)) {
                    return;
                }

                console.error('轮询获取待办事项数据失败:', error);
                if (error && error.response && error.response.status === 401) {
                    this.stopPolling();
                }
            }
        );
    }

    setPollingInterval(interval) {
        if (interval > 0) {
            this.pollingInterval = interval;
            
            // 如果当前正在轮询，重新设置定时器
            if (this.isPolling) {
                this.stopPolling();
                this.startPolling();
            }
        }
    }

    /**
     * 判断错误是否是取消操作相关的错误
     * 包括：客户端取消、请求中止、操作已取消等
     * 这些错误不应该被记录为真正的错误，避免计入 ApiError
     */
    _isCancelError(error) {
        if (!error) {
            return false;
        }

        // 检查 HTTP 状态码 499（客户端取消请求）
        if (error.response && error.response.status === 499) {
            return true;
        }

        // 检查错误消息中是否包含取消相关关键词
        const errorMessage = (error.message || '').toLowerCase();
        const errorString = JSON.stringify(error).toLowerCase();
        const errorData = error.data || error.response?.data || {};
        const errorDataString = JSON.stringify(errorData).toLowerCase();

        // 检查常见的取消相关关键词
        const cancelKeywords = [
            'cancel',
            'abort',
            'aborted',
            'operation was canceled',
            'operation canceled',
            '已取消',
            'request cancelled',
            'request canceled',
            'client canceled request',
            'the operation was canceled',
            'the operation has been canceled'
        ];

        // 检查错误消息、错误对象字符串、响应数据中是否包含取消关键词
        return cancelKeywords.some(keyword => 
            errorMessage.includes(keyword) || 
            errorString.includes(keyword) ||
            errorDataString.includes(keyword)
        );
    }
}

export default new PendingTasksPollingService();